<template>
  <div class="container">
    <div class="header">
      <button class="back-button" @click="goBack">
        <i class="fas fa-arrow-left"></i>
      </button>
      <span class="header-sapn">确认订单</span>
    </div>

    <div class="address">
      <i class="address-icon">📍</i>
      <div class="address-info">
        <span class="address-info-span">{{ address.detailedAddress }}</span>
        <!-- <span class="address-info-mobile">17467689876</span> -->
        <span class="address-info-name">{{ address.username }}  {{ address.mobileNo }}</span>
        <button class="view-more-button" @click="showMoreAddresses(address.id)">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="product-list">
      <div class="product-list-header">
        <span>提交商品信息：</span>
      </div>
      <div v-for="product in products" :key="product.id" class="product-item">
        <div class="product-image-container">
          <img :src="product.houseImageUrl" :alt="product.houseName" class="product-image" />
          <!-- <div class="product-price-tag">￥{{ product.price }}</div> -->
        </div>
        <div class="product-info">
          <div class="product-name">{{ product.houseName }}</div>
          <div class="product-category">{{ product.houseType }}</div>
          <div class="product-price">￥{{ product.housePrice }}</div>
        </div>
        <div class="product-quantity">x{{product.houseCount }}</div>
      </div>
    </div>

    <div class="summary">
      <div class="summary-item">
        <span class="summary-label">配送服务：</span>
        <span class="summary-value">快递 包邮 48小时内发货</span>
      </div>
    </div>

    <div class="price-info">
      <div class="price-detail">
        <span>价格明细</span>
      </div>
      <div class="price-total">
        <span class="total-label">商品总价</span>
        <span class="total-items"> 共{{ totalQuantity }}件宝贝</span>
        <span class="total-amount">￥{{ totalPrice }}</span>
      </div>
      <div class="price-discount">
        <span class="discount-label">共减</span>
        <span class="discount-amount">-￥0.00</span>
      </div>
      <div class="price-sumprice">
        <span class="sumprice-label">合计</span>
        <span class="sumprice-amount">￥{{ totalPrice }}</span>
      </div>
    </div>


    <div class="payment-method">
  <div class="payment-option">
    <label>
      <input
        type="radio"
        name="payment"
        value="alipay"
        v-model="paymentMethod"
      />
      <img src="./alipay.jpg" alt="支付宝" class="payment-icon" />
      支付宝
      <span class="checkmark"></span>
    </label>
  </div>
  <div class="payment-option">
    <label>
      <input
        type="radio"
        name="payment"
        value="wechat"
        v-model="paymentMethod"
      />
      <img src="./wxpay.jpg" alt="微信" class="payment-icon" />
      微信
      <span class="checkmark"></span>
    </label>
  </div>
</div>



    <div class="submit-order">
        <span>{{products.length}}款，共{{ totalQuantity }}件</span>
      <div class="order-summary">
        <span class="order-summary-total">合计：</span>
        <span class="order-summary-price">￥{{ totalPrice }}</span>
      </div>
      <button @click="submitOrder" class="submit-button">提交订单</button>
    </div>

    
  </div>
</template>
  
  <script setup>
import { ref, computed,getCurrentInstance,onMounted } from "vue";
//   import { useRoute, useRouter } from 'vue-router';
import { useRouter,useRoute } from "vue-router";

  const route = useRoute();
const router = useRouter();
const {proxy} = getCurrentInstance();

const address = ref("加载中...");
const products = ref([]);
const paymentMethod = ref("alipay");
const id = route.params.id;

// 模拟获取用户地址和商品信息
function fetchAddress() {
  // 这里替换成你的后端接口调用
  // axios.get('/api/address').then(res => {
  //   address.value = res.data.address;
  // });
  const url = '/user/queryAddress'
  proxy.$tools.request(url,{reqBody:{id :id }}).then(response =>{
    address.value = response.data.rspBody.defaultAddress;
  }).catch(error => {
    console.error(error);
  })
  
}

function fetchProducts() {
    const url = "/house/getShoppingCartInf";
      proxy.$tools
        .request(url, { reqBody: {} })
        .then((response) => {
          products.value = response.data.rspBody.shoppingCarList;
        })
        .catch((error) => {
          console.error(error);
        });
}

fetchAddress();
fetchProducts();

const totalQuantity = computed(() =>
  products.value.reduce((sum, product) => sum + product.houseCount, 0)
);

const totalPrice = computed(() => {
  return products.value.reduce((sum, product) => {
    return sum + product.houseCount * product.housePrice;
  }, 0);
});


function showMoreAddresses(id) {
  router.push({name:"AddressInfo",params:{id:id}}); // 使用 router.push 方法跳转到其他页面
}

function goBack() {
  router.go(-1);
}

function submitOrder() {
  // 这里可以处理提交订单的逻辑
  const url = "/house/createOrder";
      proxy.$tools
        .request(url, { reqBody: {productList:products.value,addressId:address.value.id,payWay:paymentMethod.value} })
        .then((response) => {
          console.log(
            "请求添加购物车订单的接口：" + JSON.stringify(response.data)
          );
          // products.value = response.data.rspBody.shoppingCarList;
        })
        .catch((error) => {
          console.error(error);
        });
  alert("订单提交成功！");
}

onMounted (() =>{
    fetchProducts();
    fetchAddress();
    });

</script>
 

 <style scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
}

.header {
  display: flex;
  justify-content: space-between; /* 左右对齐 */
  align-items: center; /* 垂直居中 */
  padding: 10px;
  position: fixed; /* 固定定位 */
  top: 0; /* 置于页面顶部 */
  left: 0; /* 确保左侧对齐 */
  width: 100%; /* 横跨整个页面 */
  /* background-color: white;  */
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 可选，为头部添加阴影效果 */
}

.back-button {
  position: relative; /* 为绝对定位的子元素提供参照 */
  border: none;
  background: none;
  cursor: pointer;
  left: 0%;
  font-size: 18px;
  margin-left: -20px;
  /* margin-left: auto;  */
  min-width: 80px; /* 设置按钮的最小宽度 */
}
.header-sapn{
    margin-right: 200px;
    font-weight: bold;
}
.address {
  display: flex;
  align-items: flex-start;
  margin-top: 60px;
  padding-left: 20px;
}

.address-icon {
  font-size: 24px;
  margin-right: 10px;
  flex: 0 0 auto;
  margin-top: 23px; /* 向下调整按钮位置 */
}

.address-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%; /* 设置宽度为100%，确保内容可以正确排列 */
}

.address-info span {
  margin-bottom: 8px;
}

.address-info-span {
  max-width: 80%; /* 设置最大宽度为页面宽度的70% */
  word-wrap: break-word; /* 允许在长单词或URL内部进行换行 */
  overflow-wrap: break-word; /* CSS3的属性，与word-wrap类似，更推荐使用 */
  font-weight: bold;
}

.address-info-mobile {
  max-width: 80%; /* 设置最大宽度为页面宽度的70% */
  word-wrap: break-word; /* 允许在长单词或URL内部进行换行 */
  overflow-wrap: break-word; /* CSS3的属性，与word-wrap类似，更推荐使用 */
  font-weight: bold;
}

.address-info-name {
  max-width: 70%; /* 设置最大宽度为页面宽度的70% */
  word-wrap: break-word; /* 允许在长单词或URL内部进行换行 */
  overflow-wrap: break-word; /* CSS3的属性，与word-wrap类似，更推荐使用 */
  color: #504848;
  font-weight: 50;
  font-size: 16px;
}

.view-more-button {
  background: none;
  border: none;
  cursor: pointer;
  align-self: flex-end; /* 将按钮对齐到右侧 */
  margin-top: 8px; /* 在按钮和上面的文本之间添加一些间距 */
  margin-right: 20px;
  transform: translateY(-50px); /* 向上调整按钮位置 */
}

.view-more-button i {
  font-size: 16px; /* 调整图标大小 */
}

.product-list {
  padding: 10px;
  max-height: 300px; /* 或者其他适合的高度 */
  overflow-y: auto;
}

.product-list-header {
  display: flex;
  align-items: center; /* 垂直居中 */
  margin-bottom: 13px; /* 添加底部间距 */
}

.product-list-header span {
  flex-shrink: 0; /* 防止商品信息文本被压缩 */
  font-weight: bold;
  font-size: 17px;
}

.product-item {
  display: flex;
  position: relative; /* 为价格标签提供定位上下文 */
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.product-image-container {
  position: relative; /* 为价格标签提供定位上下文 */
  width: 80px;
  height: 80px;
  margin-right: 10px;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-price-tag {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8); /* 半透明白色背景 */
  padding: 2px 5px;
  font-size: 12px;
  color: red;
}

.product-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.product-name {
  font-size: 16px;
  margin-bottom: 5px; /* 添加底部间距 */
}

.product-category {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px; /* 添加底部间距 */
}

.product-price {
  font-size: 14px;
  color: red;
  margin-bottom: 5px; /* 添加底部间距 */
}

.product-quantity {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 14px;
  color: #666;
}

.summary {
  padding: 10px;
}

.summary-item {
  display: flex;
  justify-content: space-between; /* 使内容在两侧对齐 */
  align-items: center; /* 垂直居中 */
}

.summary-label {
  font-size: 18px;
  /* 如果需要，可以设置样式 */
}

.summary-value {
  /* 如果需要，可以设置样式 */
  font-size: 18px;
  font-weight: bold;
}

.price-info {
  padding: 10px;
}

.price-detail {
  display: flex;
  align-items: center; /* 垂直居中 */
  margin-bottom: 13px; /* 添加底部间距 */
}

.price-detail span {
  flex-shrink: 0; /* 防止商品信息文本被压缩 */
  font-weight: bold;
  font-size: 17px;
}

.price-total,
.price-discount,
.price-sumprice {
  margin-bottom: 16px; /* 添加垂直间距 */
}

.price-total {
  display: flex;
  justify-content: space-between; /* 使内容在两侧对齐 */
  align-items: center; /* 垂直居中 */
}

.total-label {
  margin-right: 10px; /* 添加间隙 */
  font-weight: bold;
  font-size: 16px;
}

.total-items {
  margin-right: auto; /* 将这两个元素推到左侧 */
  font-size: 13px;
  color: #a7a4a4;
}

.total-amount {
  /* margin-right: 10px; */
  font-weight: bold;
  font-size: 16px;
}

.price-discount {
  display: flex;
  justify-content: space-between; /* 使内容在两侧对齐 */
  align-items: center; /* 垂直居中 */
}
.price-sumprice {
  display: flex;
  justify-content: space-between; /* 使内容在两侧对齐 */
  align-items: center; /* 垂直居中 */
}

.discount-label {
  margin-right: 10px; /* 添加间隙 */
  font-weight: bold;
  font-size: 16px;
}

.discount-amount {
  /* margin-right: 10px; */
  font-weight: bold;
  font-size: 16px;
  color: tomato;
}

.sumprice-label {
  margin-right: 10px; /* 添加间隙 */
  font-weight: bold;
  font-size: 16px;
}

.sumprice-amount {
  /* margin-right: 10px; */
  font-weight: bold;
  font-size: 16px;
}

.payment-method {
  display: flex;
  flex-direction: column;
}

.payment-option {
  display: flex;
  align-items: center; /* 保持图标和文字垂直居中 */
  justify-content: space-between; /* 确保图标和文字与复选框之间有间隔 */
  margin-bottom: 10px;
}

.payment-option label {
  display: flex;
  align-items: center; /* 保持图标和文字垂直居中 */
  cursor: pointer;
  width: 100%; /* 让 label 占据整个选项的宽度 */
}

.payment-option input {
  display: none;
}

.payment-icon {
  width: 24px; /* 根据你的图标大小调整 */
  height: 24px; /* 根据你的图标大小调整 */
  margin-right: 8px;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #aaa;
  border-radius: 50%;
  display: inline-block;
  position: relative;
}

/* 移除之前的对勾定位代码，因为我们现在要将其放在最右侧 */
.payment-option input:checked + .payment-icon + .checkmark::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(315deg);
  width: 10px;
  height: 5px;
  border: solid #333;
  /* background-color: #007bff; */
  border-width: 0 0px 2px 2px;
}

/* 确保复选框在选项的最右侧 */
.payment-option .checkmark {
  margin-left: auto; /* 将复选框推到最右侧 */
}


.submit-order {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 10px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.submit-order > span {
    margin-right: 2px; /* 添加间距 */
    font-size: 14px;
    color: #817e7e;
    font-weight: bold;
  }
.submit-button {
  padding: 13px 25px;
  background-image: linear-gradient(to right, #e7ad26, #ff6a00c9);
  color: white;
  letter-spacing: 2px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  margin-left: 10px;
}

.order-summary {
  display: flex;
  /* flex-direction: column; */
  align-items: flex-end;
  margin-right: 10px;
}

.order-summary-total{
    margin: 0; /* 移除外边距 */
    padding: 0; /* 移除内边距 */
    font-size: 15px;
    font-weight: bold;
}

.order-summary-price{
    margin: 0; /* 移除外边距 */
    padding: 0; /* 移除内边距 */
    font-size: 18px;
    font-weight: bold;
    color: tomato;
}

</style>
 
